export const permissionNames = {
  inConstruction: "inconstruction",
  superAdmin: "superadmin",
  case: {
    read: "case_read",
    edit: "case_edit",
    delete: "case_delete",
    export: "case_export",
    rpt: {
      read: "case_rpt_read",
      edit: "case_rpt_edit",
      groupRpt: "case_rpt_grouprpt",
      bulkDownload: "case_rpt_bulkdownload",
      sign: "case_rpt_sign",
      answers: "case_rpt_answers",
      publish: "case_rpt_publish",
      publishRecall: "case_rpt_publish_recall"
    },
    import: "case_import"
  },
  person: {
    read: "person_read",
    edit: "person_edit",
    new: "person_new",
    delete: "person_delete",
    import: "person_import",
    profile: "person_profile"
  },
  node: {
    read: "node_read",
    new: "node_new",
    delete: "node_delete",
    statistic: "node_statistic",
    nodeInfo: {
      read: "node_info_read",
      edit: "node_info_edit",
      qrEdit: "node_info_qredit"
    },
    testCtrl: "node_testctrl",
    rptSettings: "node_rptsettings",
    fieldConfig: "node_fieldconfig",
    identity: "node_identity"
  },
  sca: {
    group: {
      read: "sca_group_read",
      edit: "sca_group_edit",
      new: "sca_group_new",
      delete: "sca_group_delete",
      qrEdit: "sca_group_qredit"
    },
    open: {
      read: "sca_open_read",
      edit: "sca_open_edit",
      new: "sca_open_new",
      delete: "sca_open_delete",
      qrEdit: "sca_open_qredit"
    },
    indv: {
      read: "sca_indv_read",
      edit: "sca_indv_edit",
      new: "sca_indv_new",
      delete: "sca_indv_delete",
      qrEdit: "sca_indv_qredit"
    }
  },
  lb: {
    settings: {
      read: "lb_settings_read",
      edit: "lb_settings_edit",
      new: "lb_settings_new",
      delete: "lb_settings_delete",
      editCategory: "lb_settings_editcategory",
      rptDx: "lb_settings_rptdx",
      controlEngine: "lb_settings_controlengine",
      rptTemplate: "lb_settings_rpttemplate"
    },
    alert: {
      read: "lb_alert_read",
      edit: "lb_alert_edit",
      new: "lb_alert_new"
    },
    doc: {
      read: "lb_doc_read",
      quesRead: "lb_doc_quesread",
      quesExport: "lb_doc_quesexport"
    },
    groupPattern: {
      read: "lb_grouppattern_read",
      edit: "lb_grouppattern_edit",
      new: "lb_grouppattern_new",
      delete: "lb_grouppattern_delete"
    }
  },
  dashboard: {
    read: "dashboard_read",
    largeScreen: "dashboard_largescreen"
  },
  settings: {
    login: {
      user: {
        read: "settings_login_user_read",
        edit: "settings_login_user_edit",
        new: "settings_login_user_new",
        delete: "settings_login_user_delete"
      },
      role: {
        read: "settings_login_role_read",
        edit: "settings_login_role_edit",
        new: "settings_login_role_new",
        delete: "settings_login_role_delete"
      }
    },
    display: {
      edit: "settings_display_edit"
    },
    userAccount: {
      edit: "settings_user_account_edit"
    }
  },
  appoint: {
    read: "appoint_read",
    edit: "appoint_edit",
    new: "appoint_new",
    delete: "appoint_delete"
  },
  task: {
    read: "task_read",
    edit: "task_edit",
    new: "task_new",
    delete: "task_delete"
  }
};
